import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { tap } from 'rxjs';

import { I18nService } from '@core/i18n-legacy';
import { AddMemberDialogComponent, AddMemberService } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { RtPlatform } from '@core/user-interface-legacy';
import { useProtectedControlsCallback } from '@core/user-interface-routing-logic';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-add-member-dialog',
  template: ``,
  imports: [],
})
export class TellentAddMemberDialogWrapComponent extends DialogWrapComponent<AddMemberDialogComponent> {
  private readonly protectedControls = useProtectedControlsCallback();
  private readonly platform = inject(RtPlatform);
  private readonly i18n = inject(I18nService);
  private readonly svc = inject(AddMemberService);
  #open = false;

  public readonly component = AddMemberDialogComponent;
  public readonly config = {
    mobileOptions: this.platform.IS_MOBILE
      ? {
          mobileDialog: true,
          mobileViewTitle: this.i18n.translate('tlc.members.add_member.mobile_heading'),
        }
      : undefined,
    closeGuard: () => this.protectedControls(() => true),
  };

  protected async openDialog() {
    if (this.#open) return;

    this.#open = true;

    this.svc
      .openAddMemberDialogAsTellentClientCompatibleStream(this.config)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => (this.#open = false)),
      )
      .subscribe(value => this.afterClosed.emit(value));

    return Promise.resolve(void 0);
  }
}

export type TellentAddMemberDialogWebComponent = TellentWebComponent<
  TellentAddMemberDialogWrapComponent,
  'afterClosed' | 'open'
>;
